import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../../index-CROKJrb5.js";
import { c as s, f as i } from "../../../../create-component-CBAeEoQ6.js";
import { CardMeta as f } from "../../CardMeta/index.js";
const x = s(
  "MediaCardMeta",
  i(
    ({ children: r, className: a, ...t }, o) => /* @__PURE__ */ e.jsx(f, { ref: o, className: m("cur-mb-4", a), ...t, children: r })
  )
);
export {
  x as MediaCardMeta
};
//# sourceMappingURL=index.js.map
